module.exports = __webpack_public_path__ + "static/vrock-mtg_clb-ef68b189867977e068c2d6b3ed873fd3.jpg";